import { render, staticRenderFns } from "./RegionalList.vue?vue&type=template&id=f3400c0e"
import script from "./RegionalList.vue?vue&type=script&lang=js"
export * from "./RegionalList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports